import React from "react";
const TorExitNodeAdapterSummary = () => /* @__PURE__ */ React.createElement("i", null, "No configuration necessary");
export default TorExitNodeAdapterSummary;
